import { router } from 'expo-router';
import * as WebBrowser from 'expo-web-browser';
import { useState } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { Divider } from 'react-native-paper';

import { NonProfitOrgProfileResponse } from '@/api/models/nonProfitOrgModels';
import BrandedButton from '@/components/buttons/BrandedButton';
import EditButton from '@/components/buttons/EditButton';
import Text from '@/components/Text';
import { useEndFlowModal } from '@/contexts/endFlowModalContext';
import { useColor } from '@/hooks/useColor';
import { firebaseImage, safeJsonParseArray } from '@/utils/firebaseImage';
import { i18n } from '@/utils/i18n';

const ByLawsItem = ({
  canEdit,
  byLawsDoc,
  programs
}: {
  canEdit: boolean;
  byLawsDoc: NonProfitOrgProfileResponse['byLawsDoc'];
  programs: NonProfitOrgProfileResponse['programs'];
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { showError } = useEndFlowModal();

  const colors = useColor();

  const byLawsDocParsed = safeJsonParseArray(byLawsDoc ?? '');

  const onPressByLaws = async () => {
    if (byLawsDocParsed) {
      setIsLoading(true);
      try {
        let url = firebaseImage(byLawsDocParsed?.at(0));
        await WebBrowser.openBrowserAsync(url);
      } catch {
        showError({});
      }
      setIsLoading(false);
    }
  };

  return (
    <View>
      <View style={styles.titleContainer}>
        <View style={styles.titleContent}>
          <Text style={[styles.titleText, { color: colors.titleText }]} fontWeight="700">
            {i18n.t('npo_details.insights.byLaws')}
          </Text>
        </View>
        {canEdit && (
          <EditButton
            onPress={() =>
              router.navigate({
                pathname: '/edit/npoPrograms',
                params: {
                  initialByLaws: byLawsDoc,
                  initialList: JSON.stringify(programs)
                }
              })
            }
          />
        )}
      </View>
      <View style={styles.content}>
        {!byLawsDocParsed || byLawsDocParsed.length === 0 ? (
          <Text> {i18n.t('mix.n_a')}</Text>
        ) : (
          <>
            {byLawsDocParsed && byLawsDocParsed.length > 0 && (
              <BrandedButton style={styles.button} onPress={onPressByLaws} loading={isLoading}>
                {i18n.t('npo_details.insights.bylaws_button')}
              </BrandedButton>
            )}
          </>
        )}
      </View>
      <Divider />
    </View>
  );
};

export default ByLawsItem;

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  titleContent: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center'
  },

  titleText: {
    fontSize: 22,
    marginRight: 10
  },

  content: {
    marginTop: 10,
    marginBottom: 20,
    gap: 10
  },

  button: {
    borderRadius: 20,
    width: Platform.OS !== 'web' ? '50%' : '100%',
    height: 34
  }
});
